import { nanoid } from 'nanoid';
import { useEffect, useRef } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import { subscribe, useSnapshot } from 'valtio';
import SurfaceCanvas from '~/components2/Map/canvas/Surface';
import { mapState } from '~/components2/Map/Map';
import { homeMapStore } from '../store';

export default function Surface() {
  const surfaceRef = useRef<SurfaceCanvas | null>(null);
  const map = useMap();
  const { objectsAsArray, inUploadKMZMode } = useSnapshot(homeMapStore) as typeof homeMapStore;
  const containerDiv = useRef<HTMLDivElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  useEffect(() => {
    if (inUploadKMZMode) {
      surfaceRef.current?.objects.forEach((o) => {
        o.interactive = false;
      });
    } else {
      surfaceRef.current?.objects.forEach((o) => {
        o.interactive = true;
      });
    }
  }, [inUploadKMZMode, objectsAsArray]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  useEffect(() => {
    if (containerDiv.current && map.current) {
      const surface = new SurfaceCanvas({
        id: `main-surface-${nanoid()}`,
        container: containerDiv.current,
        map: map.current.getMap(),
        store: homeMapStore,
      });

      surfaceRef.current = surface;

      const unsubscribe = subscribe(mapState, () => {
        surface.refreshScreenCoords();
      });

      return () => {
        unsubscribe();
        surfaceRef.current = null;
        surface.destroy();
      };
    }
  }, []);

  if (!map.current) {
    return null;
  }

  const isVisible = objectsAsArray.length > 0;

  return (
    <div
      id="home-map-surface"
      style={{ cursor: '-moz-grab' }}
      className={`absolute left-0 top-0 ${isVisible ? 'visible' : 'hidden'}`}
      ref={containerDiv}
    ></div>
  );
}
